import TeaserCardFragment from '@/lib/fragments/teaser-card'
import { graphql } from '@/lib/query'

const SectionTeaserFragment = graphql(
  /* GraphQL */ `
    fragment SectionTeaserFragment on SectionTeaserRecord @_unmask {
      _modelApiKey
      __typename
      bg
      teasers {
        ...TeaserCardFragment
      }
    }
  `,
  [TeaserCardFragment]
)

export default SectionTeaserFragment
